// @ts-nocheck
import { yupResolver } from "@hookform/resolvers/yup";
import { Empty } from "antd";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  useCreateHubDelivery,
  useUpdateHubDelivery,
} from "hooks/hub-delivery/useHubDelivery";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import useHubForm from "../form/useHubForm";
import { validateSchema } from "./validate";
import { ADDRESS_TYPE } from "constants/address";

const partnerShipOptions = [
  {
    label: "Chành / Nhà xe",
    value: "bus",
  },
  {
    label: "Đơn vị vận chuyển",
    value: "transport",
  },
];
const formatBusOptionLabel = (option, { context }) => {
  if (context === "menu" && option.is_new_address) {
    const badgeText = option.is_new_address === "N" ? "2C" : "3C";
    const badgeColor =
      option.is_new_address === "N" ? "bg-info" : "bg-secondary";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          className={`badge ${badgeColor}`}
          style={{
            display: "inline-block",
            padding: "2px 6px",
            fontSize: "10px",
            fontWeight: "bold",
            color: "#fff",
          }}
        >
          {badgeText}
        </span>
        <span>{option.label}</span>
      </div>
    );
  }
  return option.label;
};
const DeliveryFormSection = props => {
  const [isEditReceive, setIsEditReceive] = useState(false);
  const [isEditReturn, setIsEditReturn] = useState(false);
  const { hubId, delivery, refetchHubDelivery, viewMode, activeAddressType } =
    props;
  const { t } = useTranslation(["hub"]);
  const { TWO_LEVEL, THREE_LEVEL } = ADDRESS_TYPE;

  const mainForm = useForm({
    resolver: yupResolver(validateSchema(t)),
    mode: "all",
    reValidateMode: "onChange",
  });

  const {
    control,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors },
  } = mainForm;

  const {
    onChangePartnerReceive,
    onChangePartnerReturn,
    busListOptions,
    transportListOptions,
  } = useHubForm({ mainForm, hubId });

  const openEditReceive = () => {
    setIsEditReceive(true);
  };

  const openEditReturn = () => {
    setIsEditReturn(true);
  };

  const receiveSample = useMemo(() => {
    const result = delivery?.items?.find(item => item.order_type === 2);
    return result;
  }, [delivery]);

  const returnResult = useMemo(() => {
    const result = delivery?.items?.find(item => item.order_type === 1);
    return result;
  }, [delivery]);

  useEffect(() => {
    setDefaultDataReceive(receiveSample);
    setDefaultDataReturn(returnResult);
  }, [receiveSample, returnResult, activeAddressType]);

  const formValues = watch();

  const useAsyncHubDeliveryUpdate = onSuccess =>
    useUpdateHubDelivery(onSuccess);
  const useAsyncHubDeliveryCreate = onSuccess =>
    useCreateHubDelivery(onSuccess);

  // Receive
  const setDefaultDataReceive = receiveData => {
    if (receiveData) {
      if (receiveData.transport_id === 5) {
        setValue("ship_partner_receive_sample", partnerShipOptions[0]);
        setValue("ship_unit_receive_sample", {
          label: receiveData.bus?.name,
          value: receiveData.bus_id,
        });
      } else {
        setValue("ship_partner_receive_sample", partnerShipOptions[1]);
        setValue("ship_unit_receive_sample", {
          label: receiveData.transport?.name,
          value: receiveData.transport_id,
        });
      }
      setValue(
        "use_two_level_receive_sample",
        receiveData?.is_new_address === "N"
      );
    } else {
      setValue("use_two_level_receive_sample", activeAddressType === TWO_LEVEL);
    }
  };

  const onSuccesReceive = () => {
    reset({});
    setIsEditReceive(false);
    refetchHubDelivery();
  };

  const { mutate: updateHubDeliveryReceive } =
    useAsyncHubDeliveryUpdate(onSuccesReceive);
  const { mutate: createHubDeliveryReceive } =
    useAsyncHubDeliveryCreate(onSuccesReceive);

  const onCancelReceive = () => {
    if (receiveSample) {
      setDefaultDataReceive(receiveSample);
    } else {
      reset(
        {
          ...getValues(),
          ship_partner_receive_sample: null,
          ship_unit_receive_sample: null,
        },
        { keepErrors: false }
      );
    }
    setIsEditReceive(false);
  };

  const onSaveReceive = () => {
    const data = getValues();
    const isBus = data?.ship_partner_receive_sample.value === "bus";
    const body = {
      order_type: 2,
      hub_id: hubId,
      transport_id: isBus ? 5 : data?.ship_unit_receive_sample.value,
      bus_id: isBus ? data?.ship_unit_receive_sample.value : null,
      is_new_address: data?.use_two_level_receive_sample ? "N" : "O",
    };

    if (!receiveSample) {
      createHubDeliveryReceive(body);
    } else {
      updateHubDeliveryReceive({
        hubDeliveryId: receiveSample?.id,
        data: body,
      });
    }
  };
  //

  //Return Result
  const setDefaultDataReturn = returnData => {
    if (returnData) {
      if (returnData.transport_id === 5) {
        setValue("ship_partner_return_result", partnerShipOptions[0]);
        setValue("ship_unit_return_result", {
          label: returnData.bus?.name,
          value: returnData.bus_id,
        });
      } else {
        setValue("ship_partner_return_result", partnerShipOptions[1]);
        setValue("ship_unit_return_result", {
          label: returnData.transport?.name,
          value: returnData.transport_id,
        });
      }
      setValue(
        "use_two_level_return_result",
        returnData?.is_new_address === "N"
      );
    } else {
      setValue("use_two_level_return_result", activeAddressType === TWO_LEVEL);
    }
  };

  const onSuccessReturn = () => {
    reset({});
    setIsEditReturn(false);
    setTimeout(() => {
      refetchHubDelivery();
    }, 2000);
  };
  const { mutate: updateHubDeliveryReturn } =
    useAsyncHubDeliveryUpdate(onSuccessReturn);
  const { mutate: createHubDeliveryReturn } =
    useAsyncHubDeliveryCreate(onSuccessReturn);

  const onCancelReturnResult = () => {
    if (returnResult) {
      setDefaultDataReturn(returnResult);
    } else {
      reset(
        {
          ...getValues(),
          ship_partner_return_result: null,
          ship_unit_return_result: null,
        },
        { keepErrors: false }
      );
    }
    setIsEditReturn(false);
  };

  const onSaveReturnResult = () => {
    const data = getValues();
    const isBus = data?.ship_partner_return_result.value === "bus";
    const body = {
      order_type: 1,
      hub_id: hubId,
      transport_id: isBus ? 5 : data?.ship_unit_return_result.value,
      bus_id: isBus ? data?.ship_unit_return_result.value : null,
      is_new_address: data?.use_two_level_return_result ? "N" : "O",
    };

    if (!returnResult) {
      createHubDeliveryReturn(body);
    } else {
      updateHubDeliveryReturn({
        hubDeliveryId: returnResult?.id,
        data: body,
      });
    }
  };

  return (
    <Card>
      {!viewMode && (
        <i className="mx-3 text-secondary mt-4">
          * {t("message.warningDelivery")}
        </i>
      )}
      <CardBody>
        {viewMode && !receiveSample && !returnResult && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
        {(!viewMode || receiveSample) && (
          <Row className="mb-5">
            <Col xs={12} md={viewMode ? 12 : 11}>
              <Row>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <Label htmlFor="receive_sample">
                      {t("form.order_category")}
                    </Label>
                    <input
                      type="text"
                      className={`form-control`}
                      Sectionid="receive_sample"
                      defaultValue={t("form.receive_sample")}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <Label htmlFor="ship_partner_receive_sample">
                      {t("form.ship_partner")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="ship_partner_receive_sample"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.ship_partner"),
                          })}
                          options={partnerShipOptions}
                          onChange={onChangePartnerReceive}
                          isSearchable
                          className="basic-single w-100"
                          classNamePrefix="select"
                          isDisabled={!isEditReceive}
                        />
                      )}
                    />
                    {errors.ship_partner_receive_sample && (
                      <MessageFormValidate
                        error={errors.ship_partner_receive_sample.message}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <Label htmlFor="ship_unit_receive_sample">
                      {t("form.ship_unit")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="ship_unit_receive_sample"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.ship_unit"),
                          })}
                          options={
                            formValues?.ship_partner_receive_sample?.value ===
                            "bus"
                              ? busListOptions
                              : transportListOptions
                          }
                          formatOptionLabel={
                            formValues?.ship_partner_receive_sample?.value ===
                            "bus"
                              ? formatBusOptionLabel
                              : undefined
                          }
                          isSearchable
                          className="basic-single w-100"
                          classNamePrefix="select"
                          isDisabled={!isEditReceive}
                        />
                      )}
                    />
                    {errors.ship_unit_receive_sample && (
                      <MessageFormValidate
                        error={errors.ship_unit_receive_sample.message}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={3} className="d-flex align-items-end">
                  <FormGroup className="mb-3">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="use_two_level_receive_sample"
                        disabled={!isEditReceive}
                        {...control.register("use_two_level_receive_sample")}
                        defaultChecked={activeAddressType === TWO_LEVEL}
                      />
                      <Label
                        className="form-check-label"
                        htmlFor="use_two_level_receive_sample"
                      >
                        Dùng địa chỉ 2 cấp
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            {!viewMode && (
              <Col
                xs={1}
                className="d-flex flex-row justify-content-center align-items-center"
              >
                {isEditReceive ? (
                  <>
                    <Button
                      size="sm"
                      color="primary"
                      id="btnDelete"
                      type="button"
                      className="btn btn-primary mx-2 mt-2"
                      onClick={onSaveReceive}
                    >
                      {t("button.save")}
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      id="btnDelete"
                      type="button"
                      className="btn btn-primary mt-2"
                      onClick={onCancelReceive}
                    >
                      {t("button.cancel")}
                    </Button>
                  </>
                ) : (
                  <>
                    <UncontrolledTooltip
                      placement="top"
                      target="btnEditReceive"
                    >
                      {t("button.update")}
                    </UncontrolledTooltip>
                    <button
                      id="btnEditReceive"
                      type="button"
                      className="btn"
                      onClick={openEditReceive}
                    >
                      <i className="fas fa-pen fa-2xs text-info" />
                    </button>
                  </>
                )}
              </Col>
            )}
          </Row>
        )}
        {(!viewMode || returnResult) && (
          <Row className="mb-5">
            <Col xs={12} md={viewMode ? 12 : 11}>
              <Row>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <Label htmlFor="return_result">
                      {t("form.order_category")}
                    </Label>
                    <input
                      type="text"
                      className={`form-control`}
                      id="return_result"
                      defaultValue={t("form.return_result")}
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <Label htmlFor="ship_partner_return_result">
                      {t("form.ship_partner")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="ship_partner_return_result"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.ship_partner"),
                          })}
                          options={partnerShipOptions}
                          onChange={onChangePartnerReturn}
                          isSearchable
                          className="basic-single w-100 z-index-4"
                          classNamePrefix="select"
                          isDisabled={!isEditReturn}
                        />
                      )}
                    />
                    {errors.ship_partner_return_result && (
                      <MessageFormValidate
                        error={errors.ship_partner_return_result.message}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={3}>
                  <FormGroup>
                    <Label htmlFor="ship_unit_return_result">
                      {t("form.ship_unit")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                    <Controller
                      control={control}
                      name="ship_unit_return_result"
                      render={({ field }) => (
                        <Select
                          {...field}
                          placeholder={t("placeholder.select", {
                            title: t("form.ship_unit"),
                          })}
                          options={
                            formValues?.ship_partner_return_result?.value ===
                            "bus"
                              ? busListOptions
                              : transportListOptions
                          }
                          formatOptionLabel={
                            formValues?.ship_partner_return_result?.value ===
                            "bus"
                              ? formatBusOptionLabel
                              : undefined
                          }
                          isSearchable
                          className="basic-single w-100"
                          classNamePrefix="select"
                          isDisabled={!isEditReturn}
                        />
                      )}
                    />
                    {errors.ship_unit_return_result && (
                      <MessageFormValidate
                        error={errors.ship_unit_return_result.message}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={3} className="d-flex align-items-end">
                  <FormGroup className="mb-3">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="use_two_level_return_result"
                        disabled={!isEditReturn}
                        {...control.register("use_two_level_return_result")}
                        defaultChecked={activeAddressType === TWO_LEVEL}
                      />
                      <Label
                        className="form-check-label"
                        htmlFor="use_two_level_return_result"
                      >
                        Dùng địa chỉ 2 cấp
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            {!viewMode && (
              <Col
                xs={1}
                className="d-flex flex-row justify-content-center align-items-center"
              >
                {isEditReturn ? (
                  <>
                    <Button
                      size="sm"
                      color="primary"
                      id="btnDelete"
                      type="button"
                      className="btn btn-primary mx-2 mt-2"
                      onClick={onSaveReturnResult}
                    >
                      {t("button.save")}
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      id="btnDelete"
                      type="button"
                      className="btn btn-primary mt-2"
                      onClick={onCancelReturnResult}
                    >
                      {t("button.cancel")}
                    </Button>
                  </>
                ) : (
                  <>
                    <UncontrolledTooltip
                      placement="top"
                      target="btnEditReceive"
                    >
                      {t("button.update")}
                    </UncontrolledTooltip>
                    <button
                      id="btnEditReceive"
                      type="button"
                      className="btn"
                      onClick={openEditReturn}
                    >
                      <i className="fas fa-pen  fa-2xs text-info" />
                    </button>
                  </>
                )}
              </Col>
            )}
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default DeliveryFormSection;
